const transitions = {
    duration: {
        shortest: 150,
        shorter: 200,
        short: 250,
        standard: 300,
        complex: 375,
        enteringScreen: 500,
        leavingScreen: 195,
    },
    easing: {
        easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
        easeOut: 'cubic-bezier(0.65, 0.05, 0.36, 1)',
        easeIn: 'cubic-bezier(0.65, 0.05, 0.36, 1)',
        sharp: 'cubic-bezier(0.4, 0, 0.6, 1)',
    },
};

export default transitions;
